import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, ArrowRight } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

/**
 * Renders a friendly banner nudging users without a profile to complete
 * setup. New users without profiles are intentionally excluded from the
 * "Who viewed me" feed (see backend record_profile_view), so we explain
 * that to them and link to /me to fix it.
 *
 * Renders nothing once the user has a profile.
 */
const CompleteProfileNudge = ({ context = 'views' }) => {
  const { user } = useAuth();
  if (!user || user.has_profile) return null;

  const lines = {
    views: 'Complete your profile so other members can see you here — and so your views start being counted.',
    browse: 'Complete your profile to start matching. Members can\'t find you until you do.',
  };

  return (
    <div
      className="mb-6 bg-gradient-to-r from-fnl-pink/15 via-fnl-pink/10 to-transparent border border-fnl-pink/40 rounded-2xl p-4 md:p-5 flex items-start md:items-center justify-between gap-4 flex-wrap"
      data-testid="complete-profile-nudge"
    >
      <div className="flex items-start md:items-center gap-3 flex-1 min-w-0">
        <div className="w-10 h-10 rounded-full bg-fnl-pink/25 flex items-center justify-center shrink-0">
          <Sparkles className="w-5 h-5 text-fnl-pink" />
        </div>
        <div className="min-w-0">
          <div className="text-white font-bold">Finish setting up your profile</div>
          <div className="text-purple-200 text-sm">{lines[context] || lines.views}</div>
        </div>
      </div>
      <Link
        to="/me"
        className="inline-flex items-center gap-1.5 bg-fnl-pink hover:bg-fnl-pink text-white px-4 py-2 rounded-full font-semibold text-sm transition-transform hover:scale-[1.03] shrink-0"
        data-testid="complete-profile-cta"
      >
        Complete profile <ArrowRight className="w-4 h-4" />
      </Link>
    </div>
  );
};

export default CompleteProfileNudge;
